import api from "./api";

// Helper function to handle API responses
const handleApiResponse = (response) => {
  if (response.status === 200) {
    return response.data;
  } else {
    console.warn("Unexpected Response:", response);
    return { error: "Unexpected response from server" };
  }
};

// Helper function to handle API errors
const handleApiError = (error) => {
  console.error("Error fetching data:", error);
  return { error: error.message };
};

export const fetchDriverPartnerAnalyticsSummary =
  async () => {
    try {
      const response = await api.get(
        "/driver-partner-analytics/summary"
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  };

export const fetchPartnerPerformance =
  async () => {
    try {
      const response = await api.get(
        "/driver-partner-analytics/partner-performance"
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  };

export const fetchCommissionLiability =
  async () => {
    try {
      const response = await api.get(
        "/driver-partner-analytics/commission-liability"
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  };

export const fetchPaidCommissions =
  async () => {
    try {
      const response = await api.get(
        "/driver-partner-analytics/paid-commissions"
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  };

export const fetchSuspiciousReferrals =
  async () => {
    try {
      const response = await api.get(
        "/driver-partner-analytics/suspicious-referrals"
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  };

export const fetchReferredDriverLocations =
  async () => {
    try {
      const response = await api.get(
        "/driver-partner-analytics/referred-driver-locations"
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  };

export const fetchTopPerformingPartners =
  async (limit = 10) => {
    try {
      const response = await api.get(
        "/driver-partner-analytics/top-performing-partners",
        {
          params: { limit },
        }
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  };